import type { ComponentType } from '@grafikr/components';
import fastdom from 'fastdom';

const Component: ComponentType = (node) => {
  const heightThreshold = node.offsetHeight;
  let isBelowHeader = window.scrollY > heightThreshold;

  document.documentElement.style.setProperty('--header-height', `${heightThreshold}px`);

  window.addEventListener('scroll', () => {
    fastdom.measure(() => {
      isBelowHeader = window.scrollY > heightThreshold;
    });
    fastdom.mutate(() => {
      if (isBelowHeader) {
        if (!node.classList.contains('header--fixed')) {
          node.classList.add('header--fixed', 'animate-down');
          document.body.style.paddingTop = `${heightThreshold}px`;

          setTimeout(() => node.classList.remove('animate-down'), 500);
        }
      } else {
        node.classList.remove('header--fixed', 'animate-down');
        document.body.style.paddingTop = null;
      }
    });
  });

  const dropdownButtons = node.querySelectorAll('[data-dropdown-toggle]');

  dropdownButtons.forEach((button) => {
    let active = false;
    const dropdown = button.nextElementSibling.nextElementSibling;
    const closeButton = dropdown.querySelector('[data-close]');

    const toggle = async () => {
      dropdown.classList.toggle('-translate-y-full');
      button.nextElementSibling.classList.toggle('invisible');
      button.nextElementSibling.classList.toggle('opacity-0');

      active = !active;

      if (active) {
        const disableScroll = (
          await import(
            /* webpackChunkName: "scroll-lock" */
            'modules/scroll-lock'
          )
        ).default.disablePageScroll;
        disableScroll();
      } else {
        const enableScroll = (
          await import(
            /* webpackChunkName: "scroll-lock" */
            'modules/scroll-lock'
          )
        ).default;
        enableScroll.clearQueueScrollLocks();
        enableScroll.enablePageScroll();
      }
    };

    button.addEventListener('click', toggle);
    closeButton.addEventListener('click', toggle);
  });
};

export default Component;
